import { Configuration, ITask } from '@axelity/actasign-sic'

export interface ISupercedeTaskWithMobileRequest {
  user: string
  mobile?: string // E.164 format, 10-14 characters (e.g., +41791234567)
}

/**
 * Supercede (delegate) a task to another user with optional mobile number
 *
 * This service provides a direct API call to the supercede endpoint,
 * allowing the mobile number to be passed when delegating to non-members
 * who require AES/QES signatures.
 *
 * Mobile number must be in E.164 format with length 10-14 characters.
 *
 * @param taskId - The ID of the task to delegate
 * @param request - The delegation request with user ID and optional mobile
 * @returns Promise resolving to the updated task
 */
export const supercedeTaskWithMobile = async (
  taskId: string,
  request: ISupercedeTaskWithMobileRequest
): Promise<ITask> => {
  const response = await fetch(
    `${Configuration.BASE_URL}/tasks/${taskId}/supercede`,
    {
      method: 'PUT',
      headers: {
        'Authorization': Configuration.ACCESS_TOKEN,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(request),
    }
  )

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.detail || 'Failed to delegate task')
  }

  if (response.status === 201) {
    return await response.json()
  }

  throw new Error('Unexpected response status')
}
